/* Elite R2 (REFONTE-02) — interactions sobres, sans dépendance.
   Méga-menu par pièce, menu mobile plein écran, apparitions au défilement,
   onglets de fiche produit, barre d’achat collante. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  // contenu différé : <template data-er-lazy> remplacé par son contenu à la 1re utilisation
  const hydrate = (root) => {
    const tpl = root && root.querySelector(':scope > template[data-er-lazy]');
    if (!tpl) return;
    tpl.replaceWith(tpl.content.cloneNode(true));
    if (window.EliteR2) { window.EliteR2.initScrollers(root); window.EliteR2.initReveal(); }
  };
  const desktop = window.matchMedia('(min-width: 769px)');

  /* ---------- Méga-menu (desktop) : survol avec intention + clavier ---------- */
  const initMega = () => {
    const nav = document.querySelector('[data-elite-nav]');
    if (!nav) return;
    const backdrop = document.querySelector('.elite-backdrop');
    const items = [...nav.querySelectorAll('.elite-nav__item[data-has-mega]')];
    const panelOf = (item) => document.getElementById(item.dataset.panel);
    let openItem = null;
    let timer;
    const close = (item = openItem) => {
      if (!item) return;
      item.classList.remove('is-open');
      panelOf(item)?.classList.remove('is-open');
      item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
      if (item === openItem) openItem = null;
      if (!openItem) backdrop?.classList.remove('is-on');
    };
    const open = (item) => {
      hydrate(panelOf(item));
      if (openItem && openItem !== item) close(openItem);
      openItem = item;
      item.classList.add('is-open');
      panelOf(item)?.classList.add('is-open');
      item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true');
      backdrop?.classList.add('is-on');
    };
    const later = (fn, ms) => { clearTimeout(timer); timer = setTimeout(fn, ms); };
    items.forEach((item) => {
      const btn = item.querySelector('[aria-expanded]');
      const panel = panelOf(item);
      item.addEventListener('mouseenter', () => { if (desktop.matches) later(() => open(item), openItem ? 0 : 90); });
      item.addEventListener('mouseleave', () => later(() => close(item), 180));
      panel?.addEventListener('mouseenter', () => clearTimeout(timer));
      panel?.addEventListener('mouseleave', () => later(() => close(item), 180));
      btn?.addEventListener('click', (e) => {
        e.preventDefault();
        if (item.classList.contains('is-open')) { close(item); return; }
        open(item);
        panel?.querySelector('a')?.focus();
      });
      panel?.addEventListener('focusout', (e) => {
        if (!panel.contains(e.relatedTarget) && !item.contains(e.relatedTarget)) close(item);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && openItem) {
        const btn = openItem.querySelector('[aria-expanded]');
        close();
        btn?.focus();
      }
    });
    backdrop?.addEventListener('click', () => close());
    window.addEventListener('scroll', () => { if (openItem && window.scrollY > 400) close(); }, { passive: true });
  };

  /* ---------- Menu mobile plein écran ---------- */
  const initDrawer = () => {
    const drawer = document.querySelector('[data-elite-drawer]');
    const burger = document.querySelector('.elite-burger');
    if (!drawer || !burger) return;
    let lastFocus;
    const focusables = () => [...drawer.querySelectorAll('a[href], button:not([disabled]), input')].filter((el) => el.offsetParent !== null);
    const body = drawer.querySelector('.elite-drawer__body');
    const bindPieces = () => {
      drawer.querySelectorAll('.elite-drawer__piece-toggle:not([data-bound])').forEach((t) => {
        t.dataset.bound = '1';
        if (t.tagName !== 'BUTTON') return;
        t.addEventListener('click', () => {
          const on = t.getAttribute('aria-expanded') !== 'true';
          t.setAttribute('aria-expanded', String(on));
          t.nextElementSibling?.toggleAttribute('inert', !on);
        });
      });
    };
    const setOpen = (on) => {
      if (on) { hydrate(body); bindPieces(); }
      drawer.classList.toggle('is-open', on);
      drawer.setAttribute('aria-hidden', String(!on));
      drawer.toggleAttribute('inert', !on);
      burger.setAttribute('aria-expanded', String(on));
      document.documentElement.classList.toggle('er-lock', on);
      if (on) {
        lastFocus = document.activeElement;
        setTimeout(() => drawer.querySelector('.elite-drawer__close')?.focus(), reduce.matches ? 0 : 60);
      } else {
        lastFocus?.focus();
      }
    };
    burger.addEventListener('click', () => setOpen(true));
    drawer.querySelectorAll('[data-elite-close]').forEach((b) => b.addEventListener('click', () => setOpen(false)));
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setOpen(false);
      if (e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    desktop.addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  };

  /* ---------- Apparition au défilement ---------- */
  const initReveal = () => {
    const els = document.querySelectorAll('.er-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Onglets accessibles (fiche produit, pages) ---------- */
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-er-tabs]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      const tabs = [...box.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (panel && on) hydrate(panel);
        });
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          const k = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (k) { e.preventDefault(); select(tabs[(i + k + tabs.length) % tabs.length], true); }
          if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
          if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
        });
      });
    });
  };


  /* ---------- Barre d'achat collante (fiche) : ajout direct de la variante choisie ---------- */
  const initStickyBuy = () => {
    document.querySelectorAll('[data-er-buy]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = document.querySelector('.js-product-form-main [name="add"]');
        if (target && !target.disabled) { target.click(); return; }
        const anchor = document.querySelector(btn.dataset.anchor || '.product-info');
        (anchor || document.querySelector('.product-info'))?.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  };

  /* ---------- Carrousels : flèches précédent / suivant ---------- */
  const initScrollers = (root = document) => {
    root.querySelectorAll('[data-er-scroller]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      const track = box.querySelector('.er-scroller__track');
      const btns = box.querySelectorAll('.er-scroller__btn');
      if (!track) return;
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        btns.forEach((b) => { b.disabled = b.dataset.dir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
      };
      btns.forEach((b) => b.addEventListener('click', () => {
        track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.9, behavior: reduce.matches ? 'auto' : 'smooth' });
      }));
      track.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(track);
      sync();
    });
  };

  /* ---------- Vidéo du héros : pause accessible + respect de « réduire les animations » ---------- */
  const initVideo = () => {
    document.querySelectorAll('[data-er-video]').forEach((v) => {
      const btn = v.closest('section')?.querySelector('[data-er-video-toggle]');
      const set = (paused) => {
        if (paused) v.pause(); else v.play().catch(() => {});
        btn?.setAttribute('aria-pressed', String(paused));
      };
      btn?.addEventListener('click', () => set(!v.paused));
      if (reduce.matches) { set(true); return; }
      // démarrage après le chargement complet : la vidéo ne retarde pas l'affichage de l'image d'accroche
      const start = () => setTimeout(() => { v.preload = 'auto'; set(false); }, 600);
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    });
  };

  /* ---------- Recherche : suggestions populaires quand le champ est vide ---------- */
  const initSearchPop = () => {
    document.querySelectorAll('[data-er-search-pop]').forEach((pop) => {
      const form = pop.closest('form');
      const input = form?.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;
      let t;
      const sync = () => { pop.hidden = !(document.activeElement === input || form.contains(document.activeElement)) || input.value.trim() !== ''; };
      input.addEventListener('focus', sync);
      input.addEventListener('input', sync);
      form.addEventListener('focusout', () => { clearTimeout(t); t = setTimeout(sync, 150); });
      form.addEventListener('keydown', (e) => { if (e.key === 'Escape') { pop.hidden = true; } });
    });
  };

  const init = () => { initMega(); initDrawer(); initReveal(); initTabs(); initStickyBuy(); initScrollers(); initVideo(); initSearchPop(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => { initReveal(); initTabs(e.target); initScrollers(e.target); });
  window.EliteR2 = { initReveal, initTabs, initScrollers };
})();
